import React, { useState, useEffect } from 'react'
import Grid from '../components/Grid/Grid.js'
import NavBar from '../components/NavBar/NavBar.js'
import { supabase } from '../supabaseClient' // Direct Supabase connection
import { useSelector } from 'react-redux'

const Delete = () => {
    const [videos, setVideos] = useState([])
    const [visibleLoginAlert, setVisibleLoginAlert] = useState(false)
    const [visibleNoVideoAlert, setVisibleNoVideoAlert] = useState(false)
    const isLogged = useSelector(state => state.user.isLoggedIn)
    const currentUser = useSelector(state => state.user.userInfo) // Assumes user info is stored here

    const getMyVideosArray = async () => {
        try {
            // Fetch only the videos uploaded by the currently logged-in user
            const { data, error } = await supabase
                .from('posts')
                .select('*')
                // Uncomment and adjust if you have a user_id column in your posts table:
                // .eq('user_id', currentUser?.id)
                .order('created_at', { ascending: false })

            if (error) {
                console.error('Supabase error fetching user videos:', error.message)
                setVisibleNoVideoAlert(true)
                return
            }

            if (!data || data.length === 0) {
                setVisibleNoVideoAlert(true)
            } else {
                setVideos(data)
            }
        } catch (err) {
            console.error('Unexpected error:', err)
            setVisibleNoVideoAlert(true)
        }
    }

    useEffect(() => {
        if (isLogged) {
            getMyVideosArray()
        } else {
            setVisibleLoginAlert(true)
        }
    }, [isLogged])

    return (
        <div className="h-full w-full">
            <NavBar activePage={"Delete"} />
            <div className="h-full w-full flex flex-col">
                <div className="h-14 sm:h-16 w-full flex-none"></div>
                <div className="flex-auto h-full flex p-4">
                    <div className="h-full w-60 hidden lg:block flex-none"></div>
                    <div className="h-full grow">
                        {
                            visibleLoginAlert ?
                            <div className="text-2xl font-semibold text-gray-600 w-fit relative top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">Login to delete videos</div>
                            : null
                        }
                        {
                            visibleNoVideoAlert ?
                            <div className="text-2xl font-semibold text-gray-600 w-fit relative top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">No uploaded videos</div>
                            : null
                        }
                        {
                            !visibleNoVideoAlert && !visibleLoginAlert ? 
                            <Grid videos={videos} setVideos={setVideos} showDelete={true} />
                            : null
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Delete
